export const toNumericString = (
  value: string | null | undefined,
  fallback: string | null = ''
): string | null => {
  if (!value) return fallback

  const num = Number(value)

  if (Number.isNaN(num)) return fallback

  return num.toString()
}

export const toNumericInt = (
  value: string | number | null | undefined,
  fallback: number | null = null
): number | null => {
  if (!value && value !== 0) return fallback

  const num = Number(value)

  if (Number.isNaN(num)) return fallback

  return num
}
